var m6Gdpr = window.m6Gdpr || {};

m6Gdpr = {
    REGISTER_GDPR_INFOS: 'register_gdpr_infos',
    REGISTER_IAB_INFOS: 'register_iab_infos',
    OPEN_GDPR: 'open_gdpr',
    _cookieClick: null,
    _cookieConsentement: null,
    _initialized: false,
    init: function () {
        var globalConfig = {};
        var _this = this;
        if (window.hasOwnProperty('m6GdprJSONExtra') && typeof m6GdprJSONExtra === 'object') {
            for (var attrname in m6GdprJSONExtra) {
                globalConfig[attrname] = m6GdprJSONExtra[attrname];
            }
        }

        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        }

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            var cookieString = cname + "=" + cvalue + ";" + expires + ";path=/";

            if (typeof globalConfig.cookies_all_subdomains !== 'undefined'
                && globalConfig.cookies_all_subdomains === true
                && _this.getDomain() !== null) {
                cookieString += (';domain=' + _this.getDomain());
            }

            document.cookie = cookieString;
        }

        if (m6Gdpr._initialized) {
            throw 'Already initialized';
        }

        m6Gdpr._initialized = true;

        var COOKIE_CLICK = 'cookie_consent_click';
        var COOKIE_CONSENTEMENT = 'cookie_consent_rules';

        m6Gdpr._cookieClick = getCookie(COOKIE_CLICK);
        m6Gdpr._cookieConsentement = getCookie(COOKIE_CONSENTEMENT);

        /** ---- BEGIN IAB Section */
        m6IABManager.init();
        /** ---- END IAB Section */

        window.addEventListener(m6Gdpr.REGISTER_GDPR_INFOS, function (event) {
            var version = 1;
            if (window.hasOwnProperty('m6GdprJSONExtra') && typeof m6GdprJSONExtra === 'object') {
                if(typeof m6GdprJSONExtra.version !== 'undefined' && typeof m6GdprJSONExtra.version === 'number')
                    version = m6GdprJSONExtra.version;
            }

            var choices = event.detail.choices;

            // Send
            var xhr = new XMLHttpRequest();
            xhr.open('POST', 'https://api-gdpr.m6tech.net/');
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send(encodeURI(
                'choices=' + choices +
                '&iabConsentString=' + (typeof m6IABManager !== 'undefined' ? m6IABManager.getConsentString() : '0') +
                '&version=' + version +
                '&screenWidth=' + top.window.outerWidth
            ));

            setCookie(COOKIE_CLICK, '', 0);
            setCookie(COOKIE_CONSENTEMENT, choices, 395);

            m6Gdpr._cookieClick = null;
            m6Gdpr._cookieConsentement = choices;

            if (window.dataLayer) {
                window.dataLayer.push({'event': 'cookie_consent_update_rules'});
            }
        });

        if (m6Gdpr._cookieClick && !m6Gdpr._cookieConsentement) {
            window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, {detail: {choices: '1:1,2:1,3:1,4:1'}}));
            window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, {detail: {choices: null}}));
        } else if (!m6Gdpr._cookieClick && !m6Gdpr._cookieConsentement) {
            window.dispatchEvent(new CustomEvent(m6Gdpr.OPEN_GDPR));

            var clicked = false;
            var callbackFn = function (e) {
                clicked = true;
                document.removeEventListener('click', callbackFn);
            };

            document.addEventListener('click', callbackFn);

            window.onbeforeunload = function (e) {
                if (clicked && !m6Gdpr.hasCookieConsentement()) {
                    setCookie(COOKIE_CLICK, 'true', 1);
                }
            };
        }
    },
    hasCookieClick: function () {
        return null !== m6Gdpr._cookieClick;
    },
    hasCookieConsentement: function () {
        return m6Gdpr._cookieConsentement && m6Gdpr._cookieConsentement.match(/^1:(0|1),2:(0|1),3:(0|1),4:(0|1)$/);
    },
    getCookieConsentementChoices: function (index) {
        index = index || null;

        if (m6Gdpr.hasCookieConsentement()) {
            var choices = {};
            var parts = m6Gdpr._cookieConsentement.split(',');
            var p;

            for (var i = 0; i < parts.length; i++) {
                p = parts[i].split(':');
                choices[p[0]] = p[1];
            }

            if (index) {
                return choices[index];
            }

            return choices;
        }

        return null;
    },
    getDomain: function () {
        var elems = window.location.hostname.split('.');
        if (elems.length >= 2) {
            elems = elems.splice(elems.length - 2, 2);

            return elems.join('.');
        }

        return null;
    },
    getVersion: function () {
        console.log('%cCMP M6%c Version 0.1.7','color:cyan;background:black;padding: 2px;', 'color:black;');
    }
};

window.m6Gdpr = m6Gdpr;
